package com.tencent.kuikly.h5app.module

import com.tencent.kuikly.core.render.web.export.KuiklyRenderBaseModule
import com.tencent.kuikly.core.render.web.ktx.KuiklyRenderCallback
import com.tencent.kuikly.core.render.web.nvi.serialization.json.JSONObject

class KRArenaSoundModule : KuiklyRenderBaseModule() {
    private var audio: dynamic = null

    override fun call(method: String, params: String?, callback: KuiklyRenderCallback?): Any? {
        when (method) {
            "play" -> {
                val effect = params?.takeIf { it.isNotBlank() }
                    ?.let(::JSONObject)
                    ?.optString("effect")
                    .orEmpty()
                play(effect)
            }
            "stop" -> stop()
        }
        return null
    }

    private fun play(effect: String) {
        if (effect !in supportedEffects) return
        var player = audio
        if (player == null) {
            player = js("new Audio()")
            player.preload = "auto"
            player.volume = 0.68
            audio = player
        }
        runCatching {
            player.pause()
            player.src = "/assets/AIPokerHome/arena-sounds/$effect.wav"
            player.currentTime = 0
            player.play().catch { _: dynamic -> Unit }
        }
    }

    private fun stop() {
        val player = audio ?: return
        runCatching { player.pause() }
    }

    companion object {
        const val MODULE_NAME = "KRArenaSoundModule"

        private val supportedEffects = setOf(
            "click",
            "deal",
            "card",
            "check",
            "fold",
            "chips",
            "turn",
            "win",
            "loss",
            "complete",
        )
    }
}
